import VisitSalesTrend from './VisitSalesTrend';

export default (props) => <VisitSalesTrend {...props} />;
